import React from "react";
import PropTypes from "prop-types";
import { Check } from "MODULES/shared/components/Forms";
import { DO_NOT_SHIP } from "MODULES/PurchaseOrders/constants";
import { findMatch } from "LIB/arrays";

export default function DoNotShipReasonFields({
  requires_8130_3,
  requires_weight_and_dims,
  requires_picture,
  requires_trace_documentation,
  tbd,
  ...rest
}) {
  const shippingType = rest[findMatch(Object.keys(rest), "type")];
  if (shippingType.input.value !== DO_NOT_SHIP) {
    return null;
  }

  return (
    <div className="row row-col-gutters-half">
      <div className="col-md-12">
        <div className="form-group" style={{ cursor: "pointer" }}>
          <label className="control-label" htmlFor="purchase_for">
            Do Not Ship Reason <sup className="small text-danger">*</sup>
          </label>
          <div
            id="purchase_for"
            className="btn-group btn-group-justified"
            data-toggle="buttons"
          >
            <Check
              input={requires_8130_3.input}
              label="8130-3 Approval"
              icon="fa-check-circle"
            />
            <Check
              input={requires_weight_and_dims.input}
              label="Dim/Wt Approval"
              icon="fa-check-circle"
            />
            <Check
              input={requires_trace_documentation.input}
              label="Trace Doc Approval"
              icon="fa-check-circle"
            />
            <Check
              input={requires_picture.input}
              label="Picture Approval"
              icon="fa-check-circle"
            />
            <Check input={tbd.input} label="TBD" icon="fa-check-circle" />
          </div>
        </div>
      </div>
    </div>
  );
}

DoNotShipReasonFields.propTypes = {
  shipping_type: PropTypes.instanceOf(Object),
  requires_8130_3: PropTypes.shape({
    input: PropTypes.instanceOf(Object).isRequired
  }),
  requires_weight_and_dims: PropTypes.shape({
    input: PropTypes.instanceOf(Object).isRequired
  }),
  requires_picture: PropTypes.shape({
    input: PropTypes.instanceOf(Object).isRequired
  }),
  requires_trace_documentation: PropTypes.shape({
    input: PropTypes.instanceOf(Object).isRequired
  }),
  tbd: PropTypes.shape({
    input: PropTypes.instanceOf(Object).isRequired
  })
};



// WEBPACK FOOTER //
// ./app/modules/Orders/shared/ShippingFields/DoNotShipReasonFields.jsx